import { Component, OnInit, ChangeDetectorRef } from '@angular/core'
import {
  AuthService,
  CmsService,
  CmsNavigationComponent,
  User,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { CmsComponentData, SearchResults } from '@spartacus/storefront'
import { ActivatedRoute, Router } from '@angular/router'
import { PlpService } from '../plp.service'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { CommonService } from '../../../shared/services/common.service'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'
import { environment } from '../../../../environments/environment'

@Component({
  standalone: false,
  selector: 'vs-plp-category-banner',
  templateUrl: './plp-category-banner.component.html',
  styleUrls: ['./plp-category-banner.component.scss'],
})
export class PlpCategoryBannerComponent implements OnInit {
  params: any
  pageData$: Observable<SearchResults>

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private auth: AuthService,
    private cmsService: CmsService,

    private commonService: CommonService,
    public routes: ActivatedRoute,
    private breadCrumbService: BreadcrumbService,
    public router: Router,
    private cRef: ChangeDetectorRef,
    private plpService: PlpService,
    private globalMessageService: GlobalMessageService,
    private userAccountFacade: UserAccountFacade
  ) {}

  public apiurl = environment.occBaseUrl
  data$: Observable<CmsNavigationComponent> = this.componentData.data$
  user$: Observable<User>
  nodeData: any
  menuToggle = false
  navComp$ = this.cmsService.getComponentData('VSCategoryDisplayComponent')
  navCompCat$ = this.cmsService.getComponentData('VSCategoryDisplayComponent')
  routerChange$: any

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )
    this.routes.params.subscribe(
      (params) => {
        this.params = params
        this.pageData$ = this.searchProduct()
        this.setCategoryBreadCrumbs()
        this.cRef.detectChanges()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.cmsService.getComponentData('VSCategoryDisplayComponent').subscribe(
      (resultArray) => {
        this.nodeData = resultArray
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  searchProduct() {
    const urlParam = ['products', 'search']
    const url = this.commonService.constructUrl(urlParam)
    const apiParams = {
      currentPage: '0',
      fields: 'DEFAULT',
      pageSize: 50,
      query: ':relevance:allCategories:' + this.params.categoryCode,
    }
    return this.commonService.getData(url, apiParams)
  }

  setCategoryBreadCrumbs() {
    this.plpService.setCategoryBreadCrumbs(this.params.categoryCode)

    this.pageData$.subscribe(
      (res: any) => {
        this.breadCrumbService.setBreadcrumbTitle(res.currentQuery.categoryName)
        this.cRef.detectChanges()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
}
